var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-illustration"},[_c('div',{staticClass:"progress cashflow-type-background-color",style:(_vm.progressBarStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }